import util from '@/libs/util'

// license校验
export function licenseCheck() {
  return util.http({
    method: 'get',
    url: 'system/license/check'
  })
}

// license生成
export function licenseGenerate(data) {
  return util.http({
    method: 'post',
    url: 'system/license/generate',
    responseType: 'blob',
    data
  })
}

// 发送验证码短信
export function sendCaptcha(tel) {
  return util.http({
    method: 'get',
    url: `api/sms/send/captcha?telPhone=${tel}`
  })
}

// 组织机构树
export function organizationTree() {
  return util.http({
    method: 'get',
    url: 'org/auth/common/organization/tree'
  })
}

// 组织机构树有厂站
export function organizationTreeAll() {
  return util.http({
    method: 'get',
    url: 'org/auth/common/organization/tree/all'
  })
}

// 获取当前账号所属公司下还未授权厂站树
export function organizationDeptTree(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/common/organization/dept/tree',
    params
  })
}

// 父级组织机构ID列表
export function organizationParentIdList(id) {
  return util.http({
    method: 'get',
    url: `org/auth/common/organization/parentIdList?organizationId=${id}`
  })
}

// 所有区域树
export function allDivisionTree() {
  return util.http({
    method: 'get',
    url: 'system/auth/common/all/division/tree'
  })
}

// 职工列表（根据组织机构查询）
export function employeeList(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/common/employee/list',
    params
  })
}
